import React, { useState, useEffect } from 'react';
import { Rocket } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/90 backdrop-blur-lg shadow-lg border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <Rocket className="w-8 h-8 text-white" />
            <span className="text-2xl font-extrabold tracking-tight text-white">LaunchPilot</span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('capabilities')}
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
            >
              Capabilities
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
            >
              Pricing
            </button>
          </div>

          <div className="flex items-center space-x-4">
            <Button
              variant="ghost"
              className="hidden md:inline-flex text-white hover:text-white hover:bg-white/10 transition-all duration-200"
              onClick={() => scrollToSection('contact')}
            >
              Contact
            </Button>
            <Button
              className="bg-white hover:bg-gray-100 text-black font-semibold transition-all duration-300 transform hover:scale-105"
              onClick={() => window.open('https://calendly.com/rajvverma2000/30min', '_blank')}
            >
              Start Your Project
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;